import { render, staticRenderFns } from "./ProtocolForm.vue?vue&type=template&id=3f2f08e4&"
import script from "./ProtocolForm.vue?vue&type=script&lang=js&"
export * from "./ProtocolForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports